import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, graphql } from 'react-apollo'
import classnames from 'classnames'
import { camelize } from 'humps'

import { productsQuery } from 'environments/TasteProfileOnboarding/queries'
import Header from 'environments/TasteProfileOnboarding/components/Header'
import ProductBlock from 'components/ProductBlock'
import Button from 'components/Button'
import { RED, WHITE, WINE_NAMES_URL } from 'constants/wines'
import { trackTasteProfileEvent } from 'utils/tagManager'

import styles from './wineListInline.css'

export const LIMIT = 3

export class WineListInline extends Component {
  render () {
    const { data, tasteProfile } = this.props
    const url = `/wijn/${WINE_NAMES_URL[tasteProfile.color]}/?pmin=0%2C00&prefn1=tasteProfile&prefv1=${encodeURIComponent(tasteProfile.tasteProfile)}&srule=sort.by.most.sold.desc&start=0&sz=12`
    return (
      <div className={styles.wineListInline}>
        {data.products &&
        <Header className={styles.header}>
          {`Jouw top ${LIMIT} `}<br className={styles.headerBreak} /><mark
            className={classnames(
              styles.titleMark,
              styles[camelize(tasteProfile.tasteProfile)]
            )}
          >{tasteProfile.tasteProfile}</mark> wijnen
        </Header>
        }
        {data.products &&
        <div className={classnames(styles.productGrid, 'products-grid')}>
          {data.products.edges.map((node) => node.node).map((props) => (
            <div
              key={props.sku}
              className={classnames(styles.productBlockContainer, 'productblock-container')}
            >
              <ProductBlock {...props} />
            </div>
          ))}
        </div>
        }
        <div className={styles.footer}>
          <Button
            href={url}
            className={styles.viewAllWines}
            {...trackTasteProfileEvent('Naar de wijnen')}
          >
            Bekijk al jouw wijnen
          </Button>
        </div>
      </div>
    )
  }
}

WineListInline.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    products: PropTypes.shape({
      edges: PropTypes.array
    })
  }).isRequired,
  tasteProfile: PropTypes.shape({ // eslint-disable-line react/no-unused-prop-types
    color: PropTypes.oneOf([RED, WHITE]).isRequired,
    tasteProfile: PropTypes.string.isRequired,
    tasteType: PropTypes.string.isRequired,
    acidity: PropTypes.number.isRequired,
    complexity: PropTypes.number.isRequired,
    intensity: PropTypes.number.isRequired,
    sweetness: PropTypes.number.isRequired,
    tannin: PropTypes.number
  }).isRequired
}

export default compose(
  graphql(productsQuery, {
    options: ({ tasteProfile }) => ({
      fetchPolicy: 'network-only',
      variables: {
        limit: LIMIT,
        ...tasteProfile,
        availability: 'instock'
      }
    })
  })
)(WineListInline)
